import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 14l-6 -6l-6 6h12","key":"svg-0"}]]

const IconCaretUp = createReactComponent('outline', 'caret-up', 'CaretUp', __iconNode);

export default IconCaretUp;